/********************************************************************
 * Project: WDCK（2021）
 * Class: DateDirective
 * ----------------------------------------
 * <summary>
 * Number date format Directive
 * </summary>
 * <history>
 *      NghiaNX     2021/07/09      Create
 * </history>
 ********************************************************************/
import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
    selector: 'input[numberForm]'
})
export class NumberFormDirective {
    dobRegex = /[^0-9]/g;
    @Output() ngModelChange = new EventEmitter();
    constructor(private el: ElementRef) {
    }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this.el.nativeElement.value;

        if (event.inputType == 'insertText') {
            this.el.nativeElement.value = initalValue.replace(this.dobRegex, '');
            if (initalValue !== this.el.nativeElement.value) {
                if (this.el.nativeElement.value === '') {
                    this.ngModelChange.emit(initalValue);
                }
                event.stopPropagation();
            }
            else{
                this.ngModelChange.emit(initalValue);
                event.stopPropagation();
            }
        }
    }

    @HostListener('compositionend', ['$event']) onCompositionEnd(event) {
        const initalValue = this.el.nativeElement.value;
        this.el.nativeElement.value = initalValue.replace(this.dobRegex, '');
        this.ngModelChange.emit(initalValue);
    }
}
